import { remove } from '@core/api/baseApi';

export const deleteProfilePhoto = (): Promise<void> => remove('/users/profile-photo');
